import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

import { actionTypes } from 'actions/actionTypes'
import { trackOrder } from 'actions/order'
import { orderConfirmationRedirect } from 'actions/orderConfirmation'
import statusActions from 'actions/status'
import { getAccessToken, getAuthUserId, getIsAuthenticated } from 'selectors/auth'
import { getBasketDate, getBasketOrderId } from 'selectors/basket'

import { createOrder } from '../apis/orderV2'
import { getSlotForBoxSummaryDeliveryDays, getOrderV2 } from '../selectors/order'

const { pending, error } = statusActions

export const checkoutTransactionalOrder = () => async (dispatch, getState) => {
  const state = getState()
  if (!getIsAuthenticated(state)) {
    return
  }

  const userId = getAuthUserId(state)
  const [slot, slotId] = getSlotForBoxSummaryDeliveryDays(state)

  const basketDate = getBasketDate(state)
  const basketOrderId = getBasketOrderId(state)
  const deliverySlotsInState = state.boxSummaryDeliveryDays

  if (!slot) {
    datadogRum.addError(new Error(`Can't find any slot with id: ${slotId}`), {
      source: 'checkoutTransactionalOrder - slot',
      userId,
      basketDate,
      deliverySlotsInState,
      basketOrderId,
    })

    dispatch(pending(actionTypes.ORDER_SAVE, false))
    dispatch(error(actionTypes.ORDER_SAVE, `Can't find any slot with id: ${slotId}`))

    return
  }

  dispatch(statusActions.error(actionTypes.ORDER_SAVE, null))
  dispatch(statusActions.pending(actionTypes.ORDER_SAVE, true))

  // todo is this check really needed? it doesn't stop the flow in v1...
  // const couldBasketBeExpired = getCouldBasketBeExpired(getState())

  const accessToken = getAccessToken(state)
  const orderRequest = getOrderV2(state)

  try {
    const order = await createOrder(accessToken, orderRequest, userId)
    try {
      dispatch(trackOrder('create', order))
    } catch (e) {
      datadogLogs.logger.warning({
        message: 'error in tracking createOrder in checkoutTransactionalOrder',
        errors: [e],
      })
    }
    dispatch(orderConfirmationRedirect(order.id, 'create'))
    dispatch(statusActions.pending(actionTypes.ORDER_SAVE, false))
  } catch (e) {
    const { message, code } = e || {}
    datadogRum.addError(e instanceof Error ? e : new Error('Create Transactional Order Failed'), {
      source: 'checkoutTransactionalOrder - createOrder',
      message,
      errorCode: code,
      isAuthenticated: getIsAuthenticated(state),
    })
    dispatch(error(actionTypes.ORDER_SAVE, { message, code }))
  }
}
